/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";
import AppActions from "../AppActions";
import BaseCom from "../BaseCom";
import Card from "../Card";
import FormInput from "../FormInput";
import Icon from "../Icon";
import { SidebarGlobal } from "../_SidebarGlobal";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import { qreq } from "../../shared/qrequest";
import Auth from "../../shared/Auth";
import L from "../Lang";

class InventoryItem extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            info: {}
        };
        this.submitRef = React.createRef();
    }

    async componentDidMount() {
        SidebarGlobal.setSubNav(Auth.hasRole('manager') && <>
            <button className="btn btn-success" onClick={() => this.submitRef.current.click()}><Icon icon="faSave" /> <span className="d-none d-md-inline"><L>Save</L></span></button>
        </>);
        this.fillList('/api/product/list', 'products', true);
        if (this.props.params.id) {
            try {
                let j = await qreq.getAsync('/api/inventory/get/' + this.props.params.id);
                if (j.item) {
                    this.setState({ info: j.item });
                }
                else {
                    this.alert(j.errorMessage);
                }
            }
            catch (e) {
                this.unkownErrorCallback();
            }
        }
        else {
            this.setState({ info: { expirationDate: new Date() } });
        }
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    change = () => {
        this.setState({ info: { ...this.state.info } });
    }

    submit = async (e) => {
        e?.preventDefault();
        try {
            let j = await qreq.postAsync('/api/inventory/save', this.state.info);
            if (j.errorCode === 0) {
                this.props.navigate('/inventory');
            }
            else {
                this.alert(j.errorMessage);
            }
        }
        catch (e) {
            this.unkownErrorCallback();
        }
    }

    disabled = () => {
        return this.state.info?.sentToAccountID;
    }

    render() {
        return <div className="container-fluid">
            <form onSubmit={this.submit}>
                <h1><L>Item</L></h1>
                <Card title="Item Details">
                    <FormInput model={this.state.info} name="productID" label="Product" type="select"
                        options={this.state.products ?? []} optionsName="nameWithSize" required onChange={this.change} disabled={this.disabled()} />
                    <FormInput model={this.state.info} name="lotNumber" label="Lot Number" type="text" required onChange={this.change} disabled={this.disabled()} />
                    <FormInput model={this.state.info} name="expirationDate" label="Expiration Date" type="date" required onChange={this.change} disabled={this.disabled()} />
                    <FormInput model={this.state.info} name="description" label="Description" type="text" onChange={this.change} disabled={this.disabled()} />
                </Card>
                {Auth.hasRole('manager') && <AppActions>
                    <button ref={this.submitRef} className="btn btn-success btn-lg" disabled={this.disabled()}><Icon icon="faSave" /> <span className="d-none d-md-inline"><L>Save</L></span></button>
                </AppActions>}
            </form>
        </div>;
    }
}

export default withParamsAndNavigate(InventoryItem);